/**
 * Copyright © 2024 Anagog Ltd. All rights reserved.
 */

export enum TimeFrame {
    OVERALL ,
    TODAY ,
    YESTERDAY ,
    THIS_WEEK ,
    LAST_WEEK,
    LAST_7_DAYS ,
    THIS_MONTH ,
    LAST_MONTH ,
    LAST_30_DAYS ,
    LAST_YEAR ,
    THIS_YEAR 
}